import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=2f927d72&"
import script from "./NotFound.vue?vue&type=script&lang=ts&"
export * from "./NotFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f927d72')) {
      api.createRecord('2f927d72', component.options)
    } else {
      api.reload('2f927d72', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=2f927d72&", function () {
      api.rerender('2f927d72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/NotFound.vue"
export default component.exports